import React, { useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle";

const ServicesTabs = () => {
  const [activeTab, setActiveTab] = useState("service1");

  const tabData = [
    {
      id: "service1",
      title: "How to Get Consultancy?",
      icon: "assets/img/icons/service7-icon1a.png",
      image: "assets/img/images/consultancy.jpg",
      heading: "How to Get Consultancy?",
      content:
        "Getting expert legal advice has never been easier with Dm2Legal. Simply visit our website or use our mobile app to schedule a consultation with one of our legal experts. You’ll receive personalized guidance tailored to your specific needs.",
      features: [
        { title: "Easy Scheduling", description: "Book a consultation through our website." },
        { title: "Personalized Solutions", description: "Consult with experienced legal experts." },
        { title: "Quick Response", description: "Receive timely guidance for your legal queries." },
      ],
    },
    {
      id: "service2",
      title: "How Dm2Legal India Works?",
      icon: "assets/img/icons/service7-icon2a.png",
      image: "assets/img/images/works.jpg",
      heading: "How Dm2Legal Works?",
      content:
        "At Dm2Legal, we simplify the entire legal process for you. From registrations and compliance to filings and consultations, everything is handled online.",
      features: [
        { title: "Select Your Service", description: "Explore our range of legal services." },
        { title: "Submit Your Details", description: "Securely provide documents online." },
        { title: "Expert Handling", description: "Our team manages filings and compliance." },
      ],
    },
    {
      id: "service3",
      title: "Online Accounting by Dm2Legal",
      icon: "assets/img/icons/service7-icon3a.png",
      image: "assets/img/images/accounting.jpg",
      heading: "Online Accounting by Dm2Legal",
      content:
        "Simplify your finances with Dm2Legal's online accounting services. Our expert team provides accurate and timely bookkeeping, GST filing, TDS returns, and more.",
      features: [
        { title: "Comprehensive Accounting", description: "We handle bookkeeping and GST filings." },
        { title: "Cloud-Based Accessibility", description: "Manage accounts anytime, anywhere." },
        { title: "Precision and Compliance", description: "Ensure your financials meet regulations." },
      ],
    },
    {
      id: "service4",
      title: "Why Choose Dm2Legal?",
      icon: "assets/img/icons/service7-icon4a.png",
      image: "assets/img/images/choose-legal251.jpg",
      heading: "Why Choose Dm2Legal?",
      content:
        "Dm2Legal is trusted by thousands. With user-friendly technology, transparent pricing, and a comprehensive range of services, we ensure your legal needs are met with precision and care.",
      features: [
        { title: "Skilled Professionals", description: "Experienced lawyers and accountants." },
        { title: "All-Inclusive Services", description: "Legal filings, consultancy, accounting." },
        { title: "Clear Pricing", description: "Straightforward, transparent costs." },
      ],
    },
  ];

  return (
    <div className="row"  >
      <div className="col-lg-12">
        <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
          {tabData.map((tab) => (
            <li className="nav-item" role="presentation" key={tab.id}>
              <button
                className={`nav-link ${activeTab === tab.id ? "active" : ""}`}
                id={`${tab.id}-tab`}
                data-bs-toggle="pill"
                data-bs-target={`#${tab.id}`}
                type="button"
                role="tab"
                aria-controls={tab.id}
                aria-selected={activeTab === tab.id}
                onClick={() => setActiveTab(tab.id)}
              >
                <div className="single-slider" data-aos="fade-up">
                  <div className="icon">
                    <img src={tab.icon} alt="" />
                  </div>
                  <h4>{tab.title}</h4>
                </div>
              </button>
            </li>
          ))}
        </ul>
        <div className="tab-content" id="pills-tabContent">
          {tabData.map((tab) => (
            <div
              className={`tab-pane fade ${activeTab === tab.id ? "show active" : ""}`}
              id={tab.id}
              role="tabpanel"
              aria-labelledby={`${tab.id}-tab`}
              key={tab.id}
            >
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="image img100">
                    <img src={tab.image} alt="" />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="hadding7 service7-hadding">
                    <h2>{tab.heading}</h2>
                    <p className="pd-text">{tab.content}</p>
                    <div className="service7-list-hadding">
                      {tab.features.map((feature, index) => (
                        <div className="single-list" key={index}>
                          <div className="icon">
                            <img src="assets/img/icons/service7-list-icon.svg" alt="" />
                          </div>
                          <p className="pd-text">
                            <span>{feature.title}:</span> {feature.description}
                          </p>
                        </div>
                      ))}
                    </div>
                    {/* <button className="theme-btn-3">
                      Read More<span>
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesTabs;
